import * as React from "react";
const SvgFiRrPoo = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-poo_svg__a)">
      <path
        fill="#062147"
        d="M12 19a9.45 9.45 0 0 1-5.666-2.254 1 1 0 1 1 1.332-1.492 6.36 6.36 0 0 0 8.67 0 1 1 0 0 1 1.33 1.493A9.45 9.45 0 0 1 12 19m-2.5-8a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m5 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m9.5 7.5a5.48 5.48 0 0 0-2.139-4.329 4.98 4.98 0 0 0-1.9-5.178 3.513 3.513 0 0 0-3.07-3.972C16.407 2.747 14.4 0 12 0a1 1 0 0 0-1 1 4.1 4.1 0 0 1-2.195 4H7.5a3.51 3.51 0 0 0-3.465 3.993 4.98 4.98 0 0 0-1.9 5.178A5.5 5.5 0 0 0 5.5 24h13a5.506 5.506 0 0 0 5.5-5.5M9 7a1 1 0 0 0 .316-.052A5.77 5.77 0 0 0 12.9 2.309 5.24 5.24 0 0 1 15 6a1 1 0 0 0 1 1h.5a1.505 1.505 0 0 1 1.385 2.071 1 1 0 0 0 .47 1.272 2.985 2.985 0 0 1 1.4 3.842 1 1 0 0 0 .432 1.271A3.5 3.5 0 0 1 18.5 22h-13a3.5 3.5 0 0 1-1.687-6.544 1 1 0 0 0 .433-1.271 2.985 2.985 0 0 1 1.4-3.842 1 1 0 0 0 .47-1.272A1.505 1.505 0 0 1 7.5 7z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-poo_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPoo;
